<template>
  <div :class="items.length ? 'table-scroll' : ''">
    <table>
      <thead>
      <th
        v-for="(field, index) in fields"
        :key="'tr-' + index"
        :class="field.thClass"
      >
        {{ field.label }}
      </th>
      </thead>
      <tbody v-for="(item, index) in items" :key="'tr-' + index">
      <tr
        v-if="!isLast(item, index)"
        :class="{
            [getSemColor(item.id)]: true,
          }"
      >
        <td
          v-for="(field, index) in fields"
          :key="'td-' + index"
          :class="{
              [field.tdClass]: field.tdClass,
              [item.type.toLowerCase()]: field.key === 'check1',
            }"
        >
          {{
            field.type !== "checkbox" ? drawValue(item, field, index) : null
          }}
          <div
            v-if="field.key === 'note_counter'"
            :role="
                item.tasks.filter((task) => task.task_type.value === 2).length
                  ? 'button'
                  : null
              "
            class="info-box"
            @click="
                item.tasks.filter((task) => task.task_type.value === 2).length
                  ? openNoteDetailModal(
                      item.tasks.filter((task) => task.task_type.value === 2)
                    )
                  : null
              "
            v-b-tooltip="
                toTooltipTask(
                  item.tasks.filter((task) => task.task_type.value === 2),
                  'Note'
                )
              "
          >
            {{
              item.tasks.filter((task) => task.task_type.value === 2).length
            }}
          </div>
          <base-checkbox
            v-if="field.type === 'checkbox' && item.enabled"
            name="check"
            class="check"
            v-model="inputVal[item.id].check"
            @change="onCheck($event, index, item)"
            :disabled="!item.enabled"
          />
          <base-radio
            v-if="field.type === 'radio' && item.enabled"
            name="radio"
            class="check"
            v-model="inputVal[item.id].radio"
            :options="radio_options"
            :disabled="!item.enabled"
          />
        </td>
      </tr>
      <tr
        v-if="isLast(item, index)"
        :class="{
            [getSemColor(item.id)]: true,
          }"
      >
        <td
          v-for="(field, index) in fields"
          :key="'td-' + index"
          :class="{
              [field.tdClass]: field.tdClass,
              [item.type.toLowerCase()]: field.key === 'check1',
            }"
        >
          {{
            field.type !== "checkbox" ? drawValue(item, field, index) : null
          }}
          <div
            v-if="field.key === 'note_counter'"
            :role="
                item.tasks.filter((task) => task.task_type.value === 2).length
                  ? 'button'
                  : null
              "
            class="info-box"
            @click="
                item.tasks.filter((task) => task.task_type.value === 2).length
                  ? openNoteDetailModal(
                      item.tasks.filter((task) => task.task_type.value === 2)
                    )
                  : null
              "
            v-b-tooltip="
                toTooltipTask(
                  item.tasks.filter((task) => task.task_type.value === 2),
                  'Note'
                )
              "
          >
            {{
              item.tasks.filter((task) => task.task_type.value === 2).length
            }}
          </div>
          <base-checkbox
            v-if="field.type === 'checkbox' && item.enabled"
            name="check"
            class="check"
            v-model="inputVal[item.id].check"
            @change="onCheck($event, index, item)"
            :disabled="!item.enabled"
          />
          <base-radio
            v-if="field.type === 'radio' && item.enabled"
            name="radio"
            class="radio-d"
            v-model="inputVal[item.id].radio"
            :options="radio_options"
            :disabled="!item.enabled"
          />
        </td>
      </tr>
      <tr v-if="isLast(item, index)" class="subtotals">
        <td colspan="3"></td>
        <td class="text-left subtotal">SUBTOTALE</td>
        <td :colspan="fields.length - 7" class="subtotal"></td>
        <td class="sw text-right subtotal">
          {{ toLocaleCurrency(subtotals[item.registry_id].gross) }}
        </td>
        <td class="sw text-right subtotal">
          {{ toLocaleCurrency(subtotals[item.registry_id].money) }}
        </td>
        <td class="xxxsw subtotal"></td>
      </tr>
      </tbody>
      <tbody v-if="items.length">
      <tr class="totals">
        <td colspan="3"></td>
        <td class="text-left">TOTALE</td>
        <td :colspan="fields.length - 7"></td>
        <td class="sw text-right">
          {{ toLocaleCurrency(totalgross()) }}
        </td>
        <td class="sw text-right">
          {{ toLocaleCurrency(totalmoney()) }}
        </td>
        <td class="xxxsw"></td>
      </tr>
      </tbody>
      <tbody v-if="!items.length">
      <tr>
        <td
            :colspan="fields.length"
        >
          <template>
            <template v-if="newItemBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea una
                  nuova Polizza cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewItem"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                ><b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea</b-button
                >
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {drawValue} from "@/utils/advance-payments";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import {toLocaleCurrency} from "@/utils/strings";
import {toTooltipTask} from "@/utils/transforms";
import BaseRadio from "../../form/BaseRadio.vue";
import EmptyTable from "@/components/EmptyTable.vue";

export default {
  name: "sesana",
  data() {
    return {
      subtotals: {},
      radio_options: [
        {text: 'Si', value: 'Y'},
        {text: 'No', value: 'N'}]
    };
  },
  props: {
    value: null,
    fields: {
      type: Array,
    },
    items: {
      type: Array,
    },
    semColor: null,
    elaColor: null,
    performedSearch: {
      type: Boolean,
      default: false,
    },
    automaticPerformedSearch: {
      type: Boolean,
      default: false
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newItemBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseRadio,
    BaseCheckbox,
    EmptyTable,
  },
  methods: {
    drawValue,
    toLocaleCurrency,
    toTooltipTask,
    onCheck(event, index, item) {
      this.$emit("check", event, index, item);
      // this.$emit("check", { event: event.check, index, item: event });
    },
    openNoteDetailModal(array) {
      this.$emit("open_note", array);
    },
    getSemColor(id) {
      return this.semColor(id);
    },
    getElaColor(id) {
      return this.elaColor(id);
    },
    subtotalmoney(itemId) {
      return this.items
        .filter((e) => e.registry_id === itemId)
        .reduce((acc, obj) => {
          return (
            acc +
            (["S", "T:Q", "T:A", "T:P"].includes(obj.type)
              ? obj.money
              : -obj.money)
          );
        }, 0);
    },
    onAddNewItem() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    subtotalgross(itemId) {
      return this.items
        .filter((e) => e.registry_id === itemId)
        .reduce((acc, obj) => {
          return acc + obj.gross;
        }, 0);
    },
    totalmoney() {
      return Object.values(this.subtotals).reduce((acc, obj) => {
        return acc + obj.money;
      }, 0);
    },
    totalgross() {
      return Object.values(this.subtotals).reduce((acc, obj) => {
        return acc + obj.gross;
      }, 0);
    },
    isLast(item, index) {
      let next = index + 1 < this.items.length ? this.items[index + 1] : null;
      let itemId = item.registry_id;
      if (!next) {
        this.subtotals[itemId] = {};
        this.subtotals[itemId].money = this.subtotalmoney(itemId);
        this.subtotals[itemId].gross = this.subtotalgross(itemId);
        return true;
      }
      if (itemId !== next.registry_id) {
        this.subtotals[itemId] = {};
        this.subtotals[itemId].money = this.subtotalmoney(itemId);
        this.subtotals[itemId].gross = this.subtotalgross(itemId);
        return true;
      }
      return false;
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/table-mixins";
@include table-check-column;

// Importi (Lordo, Da incassare, subtotali e totali).
tbody td.text-right {
  --font-family: var(--font-family-num);
}

.table-scroll {
  overflow-y: auto;
  max-height: 350px;
}

.table-scroll thead th {
  position: sticky !important;
  top: 0;
}

table {
  //table-layout: fixed;
  width: 100%;

  // Una riga per titolo, alternate come nelle altre tabelle: qui ogni titolo ha
  // il suo tbody, quindi l'alternanza va sui tbody e non sulle righe.
  & tbody:nth-of-type(odd) tr:not(.totals) {
    background-color: var(--color-row-odd);
  }

  & tbody:nth-of-type(even) tr:not(.totals) {
    background-color: var(--color-row-even);
  }
}

table tr th,
td {
  // background-color: #fff;
  color: var(--color-text);
  padding: 2px 4px;
  text-align: left;
  .empty-results {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    align-items: center;
    justify-content: center;
    font-size: var(--font-size-md);
    font-weight: 500;
    .btn-secondary.btn--transparent.btn-secondary:not(:disabled):not(.disabled).active,
    .btn-secondary.btn--transparent.btn-secondary:not(:disabled):not(.disabled):focus {
      background-color: #fff;
    }
  }
  .or {
    position: relative;
    width: 350px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: var(--font-size-md);
    font-weight: 400;
    font-style: italic;
    cursor: default;
    // color: #333;
    margin-top: -5px; /* for visual compensation */
    &:before,
    &:after {
      position: absolute;
      width: 130px;
      height: 1px;
      top: 19px;
      background-color: var(--gray-200);
      content: '';
    }
    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
  }
}

.radio-h, .radio-d {
  min-width: 150px;
}

.zi2 {
  z-index: 2;
}

.xxxsw {
  width: 2%;
  min-width: 40px;
  max-width: 120px;
}

.xxsw {
  width: 4%;
  min-width: 60px;
  max-width: 140px;
}

.xsw {
  width: 6%;
  min-width: 80px;
  max-width: 160px;
}

.sw {
  width: 8%;
  min-width: 100px;
  max-width: 200px;
}

.mw {
  width: 10%;
  min-width: 120px;
  max-width: 240px;
}

.lw {
  width: 15%;
  min-width: 170px;
  max-width: 290px;
}

.verticalLine {
  border-right: 2px solid #00a1df;
}

// semaphore colors
// .sem-green {
//   background-color: rgb(156, 233, 156) !important;
// }
/* VERDE */
.sem-green td:nth-child(7) {
  background: inherit !important;
  border-right: 5px solid rgba(0, 255, 0, 0.4) !important;
}

// .sem-yellow {
//   background-color: rgb(236, 236, 128) !important;
// }
/* GIALLO */
.sem-yellow td:nth-child(7) {
  background: inherit !important;
  border-right: 5px solid rgba(251, 255, 0, 0.4) !important;
}

// .sem-red {
//   background-color: rgb(223, 158, 158) !important;
// }
/* ROSSO */
.sem-red td:nth-child(7) {
  background: inherit !important;
  border-right: 5px solid rgba(255, 0, 0, 0.4) !important;
}

// elaborate colors
// .ela-green {
//   background-color: rgb(156, 233, 156) !important;
// }
/* VERDE */
.ela-green td:nth-child(7) {
  background: rgb(255, 255, 255);
  background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 1) 0%,
      rgb(255, 255, 255) 25%,
      rgba(0, 255, 0, 0.4) 100%
  );
}

// .ela-yellow {
//   background-color: rgb(236, 236, 128) !important;
// }
/* GIALLO */
.ela-yellow td:nth-child(7) {
  background: rgb(255, 255, 255);
  background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 25%,
      rgba(251, 255, 0, 0.4) 100%
  );
}

// .ela-red {
//   background-color: rgb(223, 158, 158) !important;
// }
/* ROSSO */
.ela-red td:nth-child(7) {
  background: rgb(255, 255, 255);
  background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 25%,
      rgba(255, 0, 0, 0.4) 100%
  );
}

// check colors (bases on type ("A", "S", "Q", "I"))
.a {
  height: 25px;
  width: 25px;
  // background-color: #a6f8a67a;
  background: radial-gradient(#56c456, white);
  // border-radius: 25%;
  // border: 1px solid #a6f8a6;
  display: inline-block;
}

.s {
  height: 25px;
  width: 25px;
  // background-color: #f8a09d86;
  background: radial-gradient(#af545186, white);
  // border-radius: 25%;
  // border: 1px solid #f8a09d;
  display: inline-block;
}

.q,
.i {
  height: 25px;
  width: 25px;
  // background-color: #8f8d8d88;
  background: radial-gradient(#77777777, white);
  // border-radius: 25%;
  // border: 2px solid limegreen;
  display: inline-block;
}

// Subtotale per cliente: tinta chiara del colore dei totali, su tutta la riga,
// così si distingue dalle righe alternate e richiama la riga TOTALE.
.subtotals td {
  background-color: var(--color-subtotal-bg);
  border-bottom: solid 1px var(--color-total-bg);
}

.subtotal {
  font-weight: 600;
}

// .lightgray {
//   background-color: lightgray;
// }
</style>
